var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50005 0C3.80565 0 0 3.82156 0 8.53559C0 12.7635 3.06444 16.265 7.08241 16.943V10.3163H5.03195V7.93168H7.08241V6.17333C7.08241 4.13313 8.32331 3.02135 10.136 3.02135C11.0042 3.02135 11.7502 3.08631 11.9668 3.11492V5.24747L10.7096 5.24808C9.72402 5.24808 9.534 5.71829 9.534 6.40854V7.93046H11.8857L11.579 10.3151H9.534V17C13.7396 16.486 17 12.8954 17 8.53314C17 3.82156 13.1944 0 8.50005 0Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.1230e3c427efbe1adeef44e82733cbf0.svg";
export { ForwardRef as ReactComponent };